import { render } from "./hall-dialog.vue?vue&type=template&id=14ed241a&scoped=true"
import script from "./hall-dialog.vue?vue&type=script&lang=js"
export * from "./hall-dialog.vue?vue&type=script&lang=js"

import "./hall-dialog.vue?vue&type=style&index=0&id=14ed241a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-14ed241a"

export default script